import { AxiosInstance } from 'axios'

export interface GetSpecialistsPageBlockArgs {
  locale: string
}

export type PageBlock = {
  data: {
    attributes: {
      title: string
      locale: string
      department_filter_text: string
      services_filter_text: string
      problem_filter_text: string
      more_button_text: string
    }
  }
}

export const getSpecialistsPageBlock = async (client: AxiosInstance, { locale }: GetSpecialistsPageBlockArgs) => {
  const path = `/specialists-page-block`
  const params = {
    locale,
    fields: ['title', 'department_filter_text', 'services_filter_text', 'problem_filter_text', 'more_button_text'],
  }
  return (await client.get<PageBlock>(path, { params })).data.data.attributes
}
